export default __webpack_public_path__ + "static/media/newBookPage.d1a50068.png";